if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

    show(opener) {
  opener.setAttribute('aria-disabled', true);
  opener.classList.add('loading');
  opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
    .then((response) => response.text())
    .then((responseText) => {
      const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
      const productElement = responseHTML.querySelector('product-info');

this.preprocessHTML(productElement);

// 🔥 Fix: preprocessHTML macht aus data-section "quickadd-...".
// Für Section Rendering muss es wieder die originale Section sein.
if (productElement?.dataset?.originalSection) {
  productElement.dataset.section = productElement.dataset.originalSection;
}

HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

// (optional aber sehr sinnvoll) nochmal am tatsächlich eingefügten Element absichern
const inserted = this.modalContent.querySelector('product-info');
if (inserted?.dataset?.originalSection) {
  inserted.dataset.section = inserted.dataset.originalSection;
}

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }
      if (window.ProductModel) window.ProductModel.loadShopifyXR();

      super.show(opener);
    })
    .catch((e) => {
      console.error('Quick add fetch failed', e);
    })
    .finally(() => {
      opener.removeAttribute('aria-disabled');
      opener.classList.remove('loading');
      opener.querySelector('.loading__spinner').classList.add('hidden');
    });
}

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

  preventDuplicatedIDs(productElement) {
  const sectionId = productElement.dataset.originalSection || productElement.dataset.section;

  // Wichtig: section_id soll renderbar sein (template--...__main), nicht quickadd-template--...
  productElement.dataset.section = sectionId;

  const oldId = sectionId;
  const newId = `quickadd-${sectionId}`;
  productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);

  Array.from(productElement.attributes).forEach((attribute) => {
    if (attribute.value.includes(oldId)) {
      productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
    }
  });

  productElement.dataset.originalSection = sectionId;
}

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
// --- Quick Add: Update image on variant change (NEW Dawn: uses event.detail.variant) ---
(function () {
  function getScope(modal) {
    return modal.querySelector('[id^="QuickAddInfo-"]') || modal;
  }

  function pickMainImg(scope) {
    return (
      scope.querySelector('.product__media img') ||
      scope.querySelector('.product__media-item img') ||
      scope.querySelector('.product__media-wrapper img') ||
      scope.querySelector('img')
    );
  }

  function normalizeSrc(src) {
    if (!src) return null;
    if (src.startsWith('//')) return 'https:' + src;
    return src;
  }

  function variantToSrc(variant) {
    // Dawn kann featured_media ODER featured_image liefern
    const fm = variant?.featured_media;
    const fi = variant?.featured_image;

    return normalizeSrc(
      fm?.preview_image?.src ||
      fm?.src ||
      fi?.src ||
      fi ||
      null
    );
  }

  function updateImgFromVariant(modal, variant) {
    const scope = getScope(modal);
    const img = pickMainImg(scope);
    const src = variantToSrc(variant);
    if (!img || !src) return;

    img.src = src;
    img.removeAttribute('srcset');
  }

  // Wichtig: in Dawn wird das Event je nach Version unterschiedlich benannt
  const handler = (e) => {
    const modal = e.target?.closest?.('quick-add-modal');
    if (!modal) return;

    const variant = e.detail?.variant || e.detail?.productVariant || e.detail?.currentVariant;
    if (!variant) return;

    updateImgFromVariant(modal, variant);
  };

  document.addEventListener('variant:change', handler);
  document.addEventListener('variantChange', handler);
  document.addEventListener('variant-change', handler);

  // Fallback: wenn nur "change" kommt, versuchen wir über variant-selects.currentVariant zu kommen
  document.addEventListener('change', (e) => {
    const modal = e.target?.closest?.('quick-add-modal');
    if (!modal) return;

    if (!e.target.closest('variant-selects, variant-radios, .product-form__input')) return;

    const scope = getScope(modal);
    const vs = scope.querySelector('variant-selects') || scope.querySelector('variant-radios');
    const v = vs?.currentVariant || vs?.variantData?.find?.((x) => String(x.id) === String(scope.querySelector('input[name="id"]')?.value));
    if (!v) return;

    updateImgFromVariant(modal, v);
  });
})();